import { Carousel } from 'antd'
import Image from 'next/image'
import { useEffect, useState } from 'react'

const PhoneCarousel = ({
  step,
  imgHorizontal,
  currentSlide,
  setcurrentSlide,
  autoplay,
  carousel,
  setCarousel,
  className
}) => {
  const Handler = index => {
    setCarousel(step[index].img)
    setcurrentSlide(index)
  }

  useEffect(() => {
    let startX

    const handleTouchStart = e => {
      // 记录触摸起始位置
      startX = e.touches[0].clientX
    }

    const handleTouchMove = e => {
      // 计算触摸移动距离
      e.preventDefault()

      const currentX = e.touches[0].clientX
      const deltaX = currentX - startX

      // 根据 deltaX 判断左右滑动
      if (deltaX > 0) {
        if (parseInt(currentSlide) === 0) {
          setCarousel(step[step.length - 1].img)
          setcurrentSlide(step.length - 1)
        } else {
          setCarousel(step[currentSlide - 1].img)
          setcurrentSlide(currentSlide - 1)
        }
      } else if (deltaX < 0) {
        if (parseInt(currentSlide) === step.length - 1) {
          setCarousel(step[0].img)
          setcurrentSlide(0)
        } else {
          setcurrentSlide(currentSlide + 1)
          setCarousel(step[currentSlide + 1].img)
        }
      }
    }

    // 添加事件监听器
    document.addEventListener('touchstart', handleTouchStart)
    document.addEventListener('touchmove', handleTouchMove)

    // 清理工作
    return () => {
      document.removeEventListener('touchstart', handleTouchStart)
      document.removeEventListener('touchmove', handleTouchMove)
    }
  }, [currentSlide, setCarousel, setcurrentSlide, step])

  // 自动播放
  useEffect(() => {
    const interval = setInterval(() => {
      if (autoplay === true) {
        if (parseInt(currentSlide) === step.length - 1) {
          setCarousel(step[0].img)
          setcurrentSlide(0)
        } else {
          setcurrentSlide(currentSlide + 1)
          setCarousel(step[currentSlide + 1].img)
        }
      }
    }, [4000])

    // 清除定时器以避免内存泄漏
    return () => clearInterval(interval)
  }, [autoplay, currentSlide, setCarousel, setcurrentSlide, step])

  return (
    <>
      <div
        className={`${imgHorizontal
          ? 'w-[525px] Dsm:w-[calc(100vw-32px)] min-h-[360px] Dsm:min-h-[calc(100vw-125px)] px-[8px] pt-[8px] rounded-[24px]'
          : 'w-[221px] min-h-[506px] h-[506px] px-[7px] pt-[7px] rounded-[24px]'
          } border-[1px] border-[#ACB1BD] relative flex flex-col ${className}`}
      >
        <Carousel
          autoplay={autoplay}
          className={`${imgHorizontal
            ? 'w-[507px] Dsm:w-[calc(100vw-50px)] h-[315px] Dsm:h-[calc(100vw-170px)]'
            : 'w-[205px] h-[446px]'
            } flex rounded-[18px] border-[#ACB1BD] overflow-hidden border-[1px]`}
          cancelable={false}
          afterChange={index => {
            // Handler(1)
          }}
          beforeChange={(index, index2) => {
            // console.log('beforeChange', index2, index)
            // setImg(index2)
            // setCarousel(step[1].img)
          }}
        >
          {carousel.map((item, index) => {
            return (
              <div key={index} className='rounded-[15px]'>
                <Image alt='img' width={100} height={100} src={item.src} className='mx-auto w-full rounded-[15px]' />
              </div>
            )
          })}
        </Carousel>
        <div className='flex flex-1 items-center justify-center'>
          {step.map((item, i) => (
            <div
              key={i}
              className={`${currentSlide == i ? 'bg-[#2A99FF]' : 'border border-[#2A99FF]'
                } w-[12px] h-[12px] rounded-[50%] cursor-pointer mx-[6px]`}
              onClick={() => Handler(i)}
            ></div>
          ))}
        </div>
        <div className='absolute -left-[4px] top-[55px]'>
          <Image src='/images/android/1.svg' className='w-[5px] h-[24px]' width={100} height={100} alt='img' />
          <Image src='/images/android/1.svg' className='w-[5px] h-[24px] mt-4' width={100} height={100} alt='img' />
        </div>
      </div>
    </>
  )
}

export default PhoneCarousel
